import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-select components
import Select from "react-select";

import colors from "../../assest/theme/base/colors";
import styles from "./styles";

const MaterialSelect = forwardRef(({ size, error, success, customStyles, isIcon, ...rest }, ref) => {
  const { light, background, text, gradients } = colors;

  const formatOptionLabel = (option) => {
    if (!isIcon) return option.label;

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '16px' }}>{option.icon}</span>
        <span style={{ fontSize: '14px' }}>{option.label}</span>
      </div>
    );
  };

  return (
    <Select
      {...rest}
      disabled={true}
      ref={ref}
      styles={styles(size, error, success, customStyles)}
      formatOptionLabel={formatOptionLabel}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: gradients.dark.main,
          primary: gradients.dark.state,
        },
      })}
    />
  );
});

// Typechecking props for the MaterialSelect
MaterialSelect.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  error: PropTypes.bool,
  success: PropTypes.bool,
  onChange: PropTypes.func,
};

export default MaterialSelect;
